<template>
    <div class="input-l">
        <div class="input-container d-flex justify-space-between align-center" :class="inputClasses">

                <input
                        :type="isShowPassword ? 'text' : 'password'"
                        class="input-container__field"
                        :value="value"
                        :placeholder="placeholder"
                        @input="inputHandler"
                        :disabled="isDisabled"
                        @blur="isFocused = false"
                        @focus="isFocused = true"
                >
            <svg class="svg-icon icon-password" v-if="isPassword" width="16" height="18" viewBox="0 0 16 18"  xmlns="http://www.w3.org/2000/svg">
                <path class="svg" d="M4.11111 8.2V5C4.11111 3.93913 4.52083 2.92172 5.25014 2.17157C5.97945 1.42143 6.9686 1 8 1C9.0314 1 10.0206 1.42143 10.7499 2.17157C11.4792 2.92172 11.8889 3.93913 11.8889 5V8.2M2.55556 8.2H13.4444C14.3036 8.2 15 8.91634 15 9.8V15.4C15 16.2837 14.3036 17 13.4444 17H2.55556C1.69645 17 1 16.2837 1 15.4V9.8C1 8.91634 1.69645 8.2 2.55556 8.2Z"/>
            </svg>

            <svg class="svg-icon icon-user" v-else="" width="16" height="18" viewBox="0 0 16 18"  xmlns="http://www.w3.org/2000/svg">
                <path
                        class="svg"
                        d="M15 17V15.2222C15 14.2792 14.6313 13.3749 13.9749 12.7081C13.3185 12.0413 12.4283 11.6667 11.5 11.6667H4.5C3.57174 11.6667 2.6815 12.0413 2.02513 12.7081C1.36875 13.3749 1 14.2792 1 15.2222V17M11.5 4.55556C11.5 6.51923 9.933 8.11111 8 8.11111C6.067 8.11111 4.5 6.51923 4.5 4.55556C4.5 2.59188 6.067 1 8 1C9.933 1 11.5 2.59188 11.5 4.55556Z"
                />
            </svg>


            <!--<svg-icon  v-if="isPassword" name="password" />-->
            <!--<svg-icon  v-else="" name="user" />-->


            <div
                    v-if="isPassword && !isDisabled"
                    @click="eyeHandler"
                    class="eye-inner"
            >
                <eye
                        :show-line="!isShowPassword"
                />
            </div>

        </div>

        <Validation :v="v" v-if="v.$dirty"/>
    </div>

</template>

<script>
    import eye from './eye';
    import Validation from "./Validation";

    export default {
        components: {
          eye,
          Validation,
        },

        data() {
            return {
                isPressedEye: true,
                isActive: false,
                isFocused: false
            }
        },

        props: {
            value: {
              type: String,
              default: ''
            },
            placeholder: {
                type: String,
                required: false,
                default: 'Write here your password',
            },
            v: {
                type: Object,
                required: true,
            },
            type: {
                type: String,
                required: false,
                default: 'text',
            },
            isDisabled: {
                type: Boolean,
                default: false
            },
            theme: {
                type: String,
                required: false,
                default: "dark"
            },
            isHideBg: {
                type: Boolean,
                default: false
            }
        },

        computed: {
            isShowPassword() {
                return this.type === 'text' || (this.isPassword && !this.isPressedEye)
            },

            isPassword() {
                return this.type === 'password'
            },
            inputClasses() {
                let defaultTheme = this.theme === 'dark' ? 'dark-theme' : 'light-theme';
                let classes = [defaultTheme];
                if(this.isActive) {
                    classes.push('is-active')
                }
                if(!this.isDisabled && !this.v.$error && !this.isPressedEye || this.isFocused) {
                    classes.push('is-focused')
                }
                if(this.v.$error) {
                    classes.push('is-error')
                }
                if(this.isDisabled) {
                    classes.push('is-disabled')
                }
                if(this.isHideBg) {
                    classes.push('is-hide-bg')
                }

                return classes;
            },
        },

        methods: {
            eyeHandler() {
                this.isPressedEye = !this.isPressedEye;
            },

            inputHandler(event) {
                let value = event.target.value;
                if(value.length > 0) this.isActive = true
                else this.isActive = false
                this.$emit('input', value);
                this.v.$touch();
            }
        }
    }
</script>

<style lang="sass" scoped>
.input-l
    position: relative
    padding-bottom: 20px


.input-container
    position: relative
    width: 100%
    .icon-eye
        fill: #4D5F7C
        +tr(fill .3s ease)
        &:hover
            fill: white
    &__field
        +reg
        width: 100%
        outline: none
        padding: 16px 40px
        height: 48px
        font-size: $font-size--s
        border: 1px solid transparent
        background: transparent
        border-radius: 2px
        transition: border-color .3s ease, background .3s ease, padding .3s ease
    &.dark-theme
        .input-container__field
            border-color: #3C4F6F
            color: $color--white
            background: $color--dark
            &::placeholder
                color: rgba($color--white, 0.5)
        &:hover
            .input-container__field
                background: #122A50
                border-color: $input-border--hover
        &.is-active,
        &.is-focused
            .input-container__field
                background: #0C244C
                border-color: $input-border--active
                padding-left: 16px
            .svg-icon
                stroke: $input-border--active
                transform: translateX(0)
                opacity: 0
            .icon-eye
                fill: $input-border--active
                &:hover
                    fill: $color--white
        &.is-error
            .input-container__field
                background: #1D294E
                border-color: $input-border--error
                color: $input-border--error
            .svg-icon
                stroke: $input-border--error
            .icon-eye
                fill: $input-border--error
            &:hover
                fill: $input-border--error
        &.is-disabled
            .input-container__field
                background: rgba(#0C244C, 0.2)
                border-color: #23395D
            .svg-icon
                stroke: #23395D
            .icon-eye
                fill: #23395D
                cursor: default
                &:hover
                    fill: #23395D
        &.is-hide-bg
            .input-container__field
                +r(1024)
                    background: transparent
    &.light-theme
        .svg-icon
            stroke: rgba(#0B234B, 0.25)
        .icon-eye
            fill: rgba(#0B234B, 0.25)
        .input-container__field
            color: $color--dark
            border-color: rgba(#0B234B, 0.15)
            &::placeholder
                color: rgba($color--dark, 0.5)
        &:hover
            .input-container__field
                background:  #FCFDFF
                border-color: rgba(#0B234B, 0.25)
            .svg-icon
                stroke: #99A8B8
            .icon-eye
                fill: #99A8B8
        &.is-focused,
        &.is-active
            .input-container__field
                border-color: rgba(#0B234B, 0.25)
                padding-left: 16px
            .svg-icon
                transform: translateX(0)
                opacity: 0
            .icon-eye
                fill: rgba(#0B234B, 0.25)
                &:hover
                    fill: rgba(#0B234B, 0.35)
        &.is-disabled
            .input-container__field
                background: #FFFFFF
                border-color: #E9EBEF

        &.is-error
            .input-container__field
                background-color: #FFFEFE
                border-color: $input-border--error
                color: $input-border--error
            .svg-icon
                stroke: $input-border--error
            .icon-eye
                fill: $input-border--error
                &:hover
                    fill: $input-border--error


.svg-icon
    width: 14px
    height: 16px
    fill: none
    stroke: #4D5F7C
    position: absolute
    top: 50%
    transform: translateY(-50%)
    left: 15px
    +tr(all .3s ease)
.eye-inner
    display: flex
    position: absolute
    right: 10px
    cursor: pointer


</style>